// Register the service worker that backs the installable PWA.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/service-worker", { scope: "/" })
      .catch((error) => console.error("Service worker registration failed:", error));
  });
}
